import React from 'react';
import PropTypes from 'prop-types';
import { providerGenericPropType } from 'lib/CustomPropTypes/TVE';

import { block as parentBlock } from './helper';

const block = `${parentBlock}__select`;

function ProviderSelectOptions({ options, onChange }) {
  return (
    <div className={block}>
      <select onChange={onChange}>
        <option>Select TV Provider</option>
        {options.map((mvpd) => (
          <option
            key={`option-${mvpd.id}`}
            value={mvpd.id}
          >
            {mvpd.displayName}
          </option>
        ))}
      </select>
      <span className={`${block}__down icon icon-angle-down`} />
    </div>
  );
}

ProviderSelectOptions.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape(providerGenericPropType),
  ),
};

ProviderSelectOptions.defaultProps = {
  onChange: Function.prototype,
  options: [],
};

export default ProviderSelectOptions;
